import { convertMinutesToString } from "../utils/date.utils";

export const getNbMealPackages = weekData => {
  const days = weekData.data || [];
  const meal_packages = days
    .map(day => (Array.isArray(day.meal_packages) && day.meal_packages[0] && day.meal_packages[0].granted ? 1 : 0))
    .filter(e => e);
  return meal_packages.length;
};
export const checkIfWarningInvitation = weekData => {
  const days = weekData.data || [];
  const warningInvitation = days
    .filter(
      day =>
        Array.isArray(day.meal_packages) &&
        day.meal_packages[0] &&
        day.meal_packages[0].warning &&
        day.meal_packages[0].granted
    )
    .map(e => e.date);
  return warningInvitation;
};
export const getDurationTrips = daysData => {
  if (daysData)
    return daysData.reduce((res, day) => {
      const count = Number(res + day.durations.trips);
      return count;
    }, 0);
  return 0;
};

export const getDurationActivity = daysData => {
  if (daysData)
    return daysData.reduce((res, day) => {
      const count = Number(res + day.durations.activity);
      return count;
    }, 0);
  return 0;
};

export const getActivityVisits = daysData => {
  if (daysData)
    return daysData.reduce((res, day) => {
      const count = Number(res + day.durations.activity + day.durations.trips);
      return count;
    }, 0);
  return 0;
};

export const getActivityTrips = daysData => {
  if (daysData)
    return daysData.reduce((res, day) => {
      const count = Number(res + day.durations.activity + day.durations.trips);
      return count;
    }, 0);
  return 0;
};

export const getGlobalActivity = daysData => {
  if (daysData) {
    return convertMinutesToString(
      daysData.reduce((res, day) => {
        const count = Number(res + (day.durations.activity + day.durations.trips));
        return count;
      }, 0)
    );
  }
  return "0h00";
};

export const getNumberVisits = daysData => {
  if (daysData) {
    return daysData.reduce((res, day) => {
      const count = Number(res + (Array.isArray(day.visits) ? day.visits.length : 0));
      return count;
    }, 0);
  }
  return 0;
};

export const getNumberTrips = daysData => {
  if (daysData) {
    return daysData.reduce((res, day) => {
      const count = Number(res + (Array.isArray(day.trips) ? day.trips.length : 0));
      return count;
    }, 0);
  }
  return 0;
};
const isAllDayValidated = day => {
  const attendance = day.attendances || {};
  const morning = attendance.morning || {};
  const afternoon = attendance.afternoon || {};
  return morning.validated && afternoon.validated;
};
export const isAllWeekValidated = daysData => {
  if (Array.isArray(daysData)) {
    return daysData.every(isAllDayValidated);
  }
  return false;
};



// WEBPACK FOOTER //
// src/modules/presence/presence/presence.utils.js